import { AppUsers } from "./AppUsers";
import { DataSafe } from "@/models/DataSafe"


interface StringKeyArray {
    [index: string]: number;
}

export class DailyNoteData{
    static attributePrefix = "Notes";
    static attributePrefixDe = "Notizen";
}